export default "__VITE_ASSET__Bl$M4hdd__"